import { gsap } from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

export default class PageAiHero {
    constructor(el, options = {}) {
        this.el = el;
        this.svg = this.el.querySelector('.page-ai-hero--svg');
        this.options = {
            fadeInDuration: options.fadeInDuration || 0.5,
            fadeOutDuration: options.fadeOutDuration || 0.5,
            color: options.color || '#E5E6E5',
            radius: options.radius || 3,
            numCircles: options.numCircles || 5,
            minSpeed: options.minSpeed || 100,
            maxSpeed: options.maxSpeed || 200,
            flareIntervalMin: options.flareIntervalMin || 1, // Minimum seconds between flare animations
            flareIntervalMax: options.flareIntervalMax || 4 // Maximum seconds between flare animations
        };
        this.lastUsedPaths = [];
        this.prevFlarePathIndex = -1;
        this.init();
    }

    init() {
        this.paths = this.svg.querySelectorAll('path');
        this.flarePaths = this.svg.querySelectorAll('.flare-path'); // Only select paths with class ".flare-path"
        this.flare = document.querySelector('#hero-flare-1'); // Select the flare element
        this.createCircles();
        this.scheduleFlareAnimation();
    }

    createCircles() {
        for (let i = 0; i < this.options.numCircles; i++) {
            let circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("r", this.options.radius);
            circle.setAttribute("fill", this.options.color);

            this.svg.appendChild(circle);
            this.startAnimation(circle);
        }
    }

    startAnimation(circle) {
        let path = this.getRandomPath();
        this.animateCircle(circle, path);
    }

    getRandomPath() {
        let pathIndex;
        do {
            pathIndex = Math.floor(Math.random() * this.paths.length);
        } while (this.lastUsedPaths.includes(pathIndex));

        this.lastUsedPaths.push(pathIndex);
        if (this.lastUsedPaths.length > 5) {
            this.lastUsedPaths.shift();
        }

        return this.paths[pathIndex];
    }

    animateCircle(circle, path) {
        const pathLength = path.getTotalLength();
        const baseDuration = pathLength / (Math.random() * (this.options.maxSpeed - this.options.minSpeed) + this.options.minSpeed);
        const direction = Math.random() > 0.5 ? 1 : 0;

        let tl = gsap.timeline({
            onComplete: () => {
                this.startAnimation(circle);
            }
        });

        tl.fromTo(circle, {
            motionPath: {
                path: path,
                align: path,
                autoRotate: true,
                alignOrigin: [0.5, 0.5],
                start: direction ? 0 : 1,
                end: direction ? 1 : 0
            },
        }, {
            motionPath: {
                path: path,
                align: path,
                autoRotate: true,
                alignOrigin: [0.5, 0.5],
                start: direction ? 0 : 1,
                end: direction ? 1 : 0
            },
            duration: baseDuration,
            ease: "none"
        })
            .fromTo(circle, {
                opacity: 0
            }, {
                opacity: 1,
                duration: this.options.fadeInDuration,
                ease: "none"
            }, 0)
            .to(circle, {
            opacity: 0,
            duration: this.options.fadeOutDuration,
            ease: "none"
        }, `-=${this.options.fadeOutDuration}`);
    }

    scheduleFlareAnimation() {
        const interval = Math.random() * (this.options.flareIntervalMax - this.options.flareIntervalMin) + this.options.flareIntervalMin;
        setTimeout(() => {
            this.animateFlare();
            this.scheduleFlareAnimation(); // Schedule next flare animation
        }, interval * 1000);
    }

    animateFlare() {
        if (this.flarePaths.length === 0) return; // No paths available for flare

        const direction = Math.random() > 0.5 ? 1 : 0;
        let pathIndex = Math.floor(Math.random() * this.flarePaths.length);

        if(this.prevFlarePathIndex === pathIndex) {
            pathIndex = (pathIndex + 1) % this.flarePaths.length;
        }

        this.prevFlarePathIndex = pathIndex;

        const path = this.flarePaths[pathIndex];
        const pathLength = path.getTotalLength();
        const duration = pathLength / 700;


        let tl = gsap.timeline();

        tl.fromTo(this.flare, {
            motionPath: {
                path: path,
                align: path,
                autoRotate: true,
                alignOrigin: [0.5, 0.5],
                start: direction ? 0 : 1,
                end: direction ? 1 : 0
            },
        }, {
            motionPath: {
                path: path,
                align: path,
                autoRotate: true,
                alignOrigin: [0.5, 0.5],
                start: direction ? 0 : 1,
                end: direction ? 1 : 0
            },
            duration: duration,
            ease: "none"
        })
            .fromTo(this.flare, {
                opacity: 0
            }, {
                opacity: 1,
                duration: this.options.fadeInDuration * .5,
                ease: "none"
            }, 0)
            .to(this.flare, {
            opacity: 0,
            duration: this.options.fadeOutDuration * .5,
            ease: "none"
        }, `-=${this.options.fadeOutDuration * .5}`);
    }
}
